import axios from 'axios';
import apiEndpoints from 'app/constants/apiEndpoints';
import { createEntityAdapter, createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const { CLOSING_EVENTS_OUTSTANDINGS } = apiEndpoints;

export const getOutstandings = createAsyncThunk('outstandings/getOutstandings', async params => {
  const axiosParams = params && params.query ? { params: { ...params.query } } : null;
  const response = await axios.get(CLOSING_EVENTS_OUTSTANDINGS, axiosParams);
  const data = response.data.data.outstandings;
  const mapped = data.map(o => ({
    ...o,
    id: o.payments._id,
    eventId: o.id
  }));
  return mapped;
});

const outstandingsAdapter = createEntityAdapter({});

export const {
  selectAll: selectOutstandings,
  selectIds: selectOutstandingIds,
  selectById: selectOutstandingById
} = outstandingsAdapter.getSelectors(state => state.payrollPage.outstandings);

const initialState = outstandingsAdapter.getInitialState({});

const outstandingsSlice = createSlice({
  name: 'outstandings/events',
  initialState,
  reducers: {
    clearEvents: () => initialState
  },
  extraReducers: {
    [getOutstandings.fulfilled]: outstandingsAdapter.setAll
  }
});

export const { clearEvents } = outstandingsSlice.actions;

export default outstandingsSlice.reducer;
